/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Skeleton from '@dtvgo/skeleton';

/* Styles */
import './CardLiveSkeleton.scss';

function CardLiveSkeleton({ className, dark, numberOfCards }) {
  const NUMBER_OF_CARDS = numberOfCards || 10;
  return (
    <div className={`dtv-html5-c-card-live-skeleton ${className}`}>
      {Array.from({ length: NUMBER_OF_CARDS }).fill().map(() => (
        <Skeleton dark={dark} className="dtv-html5-c-card-live-skeleton__card" />
      ))}
    </div>
  );
}

CardLiveSkeleton.propTypes = {
  className: PropTypes.string,
  dark: PropTypes.bool,
  numberOfCards: PropTypes.number,
};

CardLiveSkeleton.defaultProps = {
  className: '',
  dark: false,
  numberOfCards: 10,
};

export default memo(CardLiveSkeleton);
